import { SwitchProps as SwitchPropsMui } from '@mui/material';
import { Spacing } from '../../design-system/spacing';
import { useTheme } from '../../hooks/useTheme';
import { styled } from '../../utils/styled';
import { Typography } from '../Typography';
import { StyledFormControlLabel, StyledSwitchUi } from './Switch.styles';

const StyledTypography = styled(Typography)`
  margin-left: ${({ theme }) => theme.spacing(Spacing.Tiny)};
`;

export interface SwitchProps extends SwitchPropsMui {
  readonly label?: string;
  readonly noMargin?: boolean;
}

export function Switch({
  disabled,
  noMargin = false,
  label,
  value,
  ...props
}: SwitchProps) {
  const theme = useTheme();
  return (
    <StyledFormControlLabel
      control={
        <StyledSwitchUi
          slotProps={{
            input: {
              'aria-label': label ? label : props['aria-label'],
              role: 'switch',
            },
          }}
          type="checkbox"
          {...props}
        />
      }
      disabled={disabled}
      label={
        <StyledTypography
          color={
            disabled ? theme.palette.neutral[300] : theme.palette.neutral[600]
          }
          variant="body"
        >
          {label}
        </StyledTypography>
      }
      noMargin={noMargin}
      value={value}
    />
  );
}
